import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useProxiedRef } from '../../utils/hooks/useProxiedRef.js';

var _excluded = ["defaultChecked", "checked", "indeterminate", "onChange"];
var useCheckbox = function useCheckbox(_ref, ref) {
  var _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$indeterminate = _ref.indeterminate,
      indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
      handleChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var internalRef = useProxiedRef(ref);

  var input = _extends({}, props, {
    'aria-checked': indeterminate && !checked ? 'mixed' : checked,
    checked: checked,
    onChange: handleChange,
    ref: internalRef,
    role: 'checkbox',
    tabIndex: props.disabled ? undefined : 0,
    type: 'checkbox'
  });

  return {
    input: input
  };
};

export { useCheckbox };
//# sourceMappingURL=useCheckbox.js.map
